module.exports = __webpack_public_path__ + "img/virtual_fan_1.a2a69bc.jpg";